module.exports = __webpack_public_path__ + "static/media/bevalling_huilende_baby.51742091.mp3";